import { Amount } from "@/components";
import * as Domain from "@/domain";
import { colors } from "@/styles/colors";
import { Icon, Progress } from "@/ui";
import { FunctionComponent, ReactElement } from "react";
import styles from "./Goal.module.scss";
import { IGoalProps } from "./types";

export const Goal: FunctionComponent<IGoalProps> = (
  props: IGoalProps
): ReactElement<IGoalProps> => {
  const { goal, ...restProps } = props;

  return (
    <div {...restProps}>
      <div className="blockLine">
        <h2>{goal.name}</h2>
      </div>
      <div className="fullCard mainBlockBg targetAndDebtCard shadowCard marginBottom">
        <Progress.Bar
          backgroundColor={Domain.Color.schemas[goal.color].lightBackground}
          color={goal.color}
          total={goal.limitation}
          value={goal.balance}
        />
        <div className="smallCard marginBottom">
          <Icon
            backgroundColor={goal.color}
            className={styles.iconDefault}
            color={colors.palette.white}
            icon={goal.icon}
            size={32}
          />
          <div className="cardContent">
            <Amount
              className="cardContentValue"
              currency={goal.currency}
              value={goal.balance}
            />
            <Amount
              currency={goal.currency}
              value={goal.limitation}
              renderText={(formattedValue) => (
                <span className="cardContentLabel">{`из ${formattedValue}`}</span>
              )}
            />
          </div>
        </div>
        {false && (
          <ul className="btnGroupHorizontal">
            <li className="btnGroupHorizontalLi">
              <a
                href="#"
                className="mainBtn"
                onClick={() => console.log("twoLevelModal(addIncome);")}
              >
                Доход
              </a>
            </li>
            <li className="btnGroupHorizontalLi">
              <a
                href="#"
                className="mainBtn"
                onClick={() => console.log("twoLevelModal(addExpense);")}
              >
                Расход
              </a>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};
